import { ReactNode } from 'react';

export const FieldRow = ({ label, value }: { label: string; value: ReactNode }) => (
  <tr className="border-b border-gray-100 last:border-0 dark:border-gray-700">
    <td className="py-1.5 pr-3 align-top font-mono text-xs text-gray-500 dark:text-gray-400">{label}</td>
    <td className="py-1.5 break-all font-mono text-xs text-gray-900 dark:text-gray-100">{value ?? '—'}</td>
  </tr>
);

export const FieldTable = ({ fields }: { fields: Array<[string, ReactNode]> }) => (
  <table className="w-full">
    <tbody>
      {fields.map(([label, value]) => (
        <FieldRow key={label} label={label} value={value} />
      ))}
    </tbody>
  </table>
);

const DrawerBlock = ({ title, children }: { title: string; children: ReactNode }) => (
  <div className="mb-5">
    <h3 className="mb-2 text-xs font-semibold uppercase text-gray-500 dark:text-gray-400">{title}</h3>
    {children}
  </div>
);

export default DrawerBlock;
